import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

const GooglePlacesPort = {
  add: function (app, googleMapsKey) {
    if (!googleMapsKey) {
      throw new Error("Google Maps Key is not configured.");
    }

    let places;
    setOptions({ key: googleMapsKey });

    const fetchAutocompleteSuggestions = (id, request, callback) => {
      places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request)
        .then(({ suggestions }) => {
          const formattedSuggestions = suggestions.map((s) => {
            const p = s.placePrediction;

            return {
              description: p.text.text,
              place_id: p.placeId,
              types: p.types,
            };
          });

          callback({ suggestions: formattedSuggestions, id });
        })
        .catch((error) => {
          console.log(error);
        });
    };

    importLibrary("places")
      .then((imported) => {
        places = imported;
        app.ports.googlePlacesGetAutocompleteSuggestions.subscribe(function ({
          address,
          id,
        }) {
          if (!address) {
            return;
          }
          let sessionToken = new places.AutocompleteSessionToken();

          let request = {
            input: address,
            sessionToken,
          };

          navigator.geolocation.getCurrentPosition(
            ({ coords: { latitude, longitude } }) => {
              fetchAutocompleteSuggestions(
                id,
                {
                  ...request,
                  locationBias: {
                    radius: 5000,
                    center: { lat: latitude, lng: longitude },
                  },
                },
                app.ports.googlePlacesAutocompleteSuggestionsResponse.send,
              );
            },
            () => {
              fetchAutocompleteSuggestions(
                id,
                request,
                app.ports.googlePlacesAutocompleteSuggestionsResponse.send,
              );
            },
          );
        });

        app.ports.googlePlacesGetPlaceDetails.subscribe(function ({
          placeId,
          id,
        }) {
          const place = new places.Place({ id: placeId });

          place
            .fetchFields({
              fields: [
                "addressComponents",
                "formattedAddress",
                "displayName",
                "id",
                "types",
              ],
            })
            .then((response) => {
              const transformedPlace = {
                address_components: (
                  response.place.addressComponents || []
                ).map((component) => ({
                  long_name: component.longText,
                  short_name: component.shortText,
                  types: component.types,
                })),

                formatted_address: response.place.formattedAddress,
                name: response.place.displayName,
                place_id: response.place.id,
                types: response.place.types,
              };

              const address = JSON.stringify(transformedPlace);
              app.ports.googlePlacesPlaceDetailsResponse.send({ address, id });
            })
            .catch((error) => {
              console.log("Error fetching place details:", error);
              app.ports.googlePlacesPlaceDetailsResponse.send({
                address: null,
                id,
              });
            });
        });
      })
      .catch((error) => console.log(error));
  },
};

module.exports = GooglePlacesPort;
